/* istanbul ignore file */
import React from 'react';
import _ from 'lodash';
import TopBarMenu from './TopBarMenu';
import { TRACKING } from 'common/constants/constants';
import renderMessageCenterItems from './messageCenter/menu/MessageCenterMenu';
import withMessageCenterData from './messageCenter/withMessageCenterData';
import * as TrackingService from 'common/services/tracking.service';

const doTracking = type =>
  TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
    page_tab: TRACKING.PAGE_TABS.TOPBAR,
    click_type: type
  });

const AccountSettingBar = ({
  selectedTeam,
  showAccountSettingBar,
  history,
  messages,
  markMessagesAsRead,
  applyAndFetch,
  removeMessages,
  createRepositories,
  toggleModal,
  toggleSnackBar,
  anchorEl,
  setAnchorEl,
  addRepositories,
  openRepositoriesModal,
  gitIntegrations,
  setIsProcessingRepos,
  disableMessagesCenter,
  license,
  isGroup,
  getSettingOrDefinitionValue,
  getRepositories
}) => {
  return (
    showAccountSettingBar && (
      <>
        <TopBarMenu
          id='messageCenter'
          icon='alarm'
          menuItems={messages}
          anchorEl={anchorEl.messageCenter}
          setAnchorEl={setAnchorEl}
          badgeContent={_.filter(messages, message => !message?.is_read).length}
          disableMenu={disableMessagesCenter}
          renderMenuItems={({ menuItems }) =>
            renderMessageCenterItems({
              menuItems,
              setAnchorEl,
              openRepositoriesModal: async (
                newRepositories,
                dedup_key,
                sensor_authorization_id
              ) => {
                doTracking(TRACKING.CLICK.EDIT_REPO_LIST);

                await applyAndFetch(markMessagesAsRead, dedup_key);
                await openRepositoriesModal({
                  newRepositories,
                  dedup_key,
                  sensor_authorization_id,
                  gitIntegrations,
                  createRepositories,
                  setIsProcessingRepos,
                  toggleModal,
                  toggleSnackBar,
                  setAnchorEl,
                  applyAndFetch,
                  getSettingOrDefinitionValue,
                  getRepositories
                });
              },
              addRepositories: async (newRepositories, dedup_key) => {
                doTracking(TRACKING.CLICK.ADD_THE_NEW_REPO);

                await applyAndFetch(addRepositories, {
                  newRepositories,
                  dedup_key,
                  createRepositories,
                  setIsProcessingRepos,
                  toggleSnackBar,
                  setAnchorEl,
                  getRepositories
                });
              },
              markAsRead: async (messages, type) => {
                const trackingClickType =
                  type === 'all'
                    ? TRACKING.CLICK.MARK_ALL_AS_READ
                    : TRACKING.CLICK.MARK_AS_READ;

                doTracking(trackingClickType);

                await applyAndFetch(markMessagesAsRead, messages);
              },
              deleteMessage: async messages => {
                doTracking(TRACKING.CLICK.DELETE_MESSAGE);

                await applyAndFetch(removeMessages, messages);
              },
              license
            })
          }
        />
      </>
    )
  );
};

export default withMessageCenterData(AccountSettingBar);
